  import React from "react";
  import TextField from '@material-ui/core/TextField';
  import { makeStyles } from '@material-ui/core/styles';
  import InputLabel from '@material-ui/core/InputLabel';
  import Select from '@material-ui/core/Select';
  import Input from '@material-ui/core/Input';
  import FormControl from '@material-ui/core/formControl';
  import DropdownTreeSelect from 'react-dropdown-tree-select'
  import 'react-dropdown-tree-select/dist/styles.css'
  import axios from 'axios';
  import ExpansionPanel from '@material-ui/core/ExpansionPanel';
  import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
  import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
  import Typography from '@material-ui/core/Typography';
  import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
  import IconButton from "@material-ui/core/IconButton";
  import AddIcon from "@material-ui/icons/AddCircleOutline";
  import RemoveIcon from "@material-ui/icons/RemoveCircleOutline";
  import ControlPointDuplicateIcon from '@material-ui/icons/ControlPointDuplicate';
  import Button from "@material-ui/core/Button";
  import InputAdornment from '@material-ui/core/InputAdornment';

  import CurrencyTextField from '@unicef/material-ui-currency-textfield'

  import Dialog from '@material-ui/core/Dialog';
  import DialogContent from '@material-ui/core/DialogContent';
  import DialogContentText from '@material-ui/core/DialogContentText';
  import DialogTitle from '@material-ui/core/DialogTitle';
  import DialogActions from '@material-ui/core/DialogActions';

  import {DropzoneArea} from 'material-ui-dropzone'
  import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';

  import Link from '@material-ui/core/Link';

  import Tooltip from '@material-ui/core/Tooltip';
  import Table from '@material-ui/core/Table';
  import TableBody from '@material-ui/core/TableBody';
  import TableCell from '@material-ui/core/TableCell';
  import TableHead from '@material-ui/core/TableHead';
  import TableRow from '@material-ui/core/TableRow';

  import LinearProgress from '@material-ui/core/LinearProgress';
  
  import NumberFormat from 'react-number-format';

  import  api from '../../common/api';

  class AuthorizationMatrixFormm extends React.Component {


 constructor() {
    super();

    this.state = {
      predictivo: [{authorization_matrix_task_id:"",kmPred:"", ammountPred:"", monthPred: "", rolePred:"",taskPred:"",taskLabel:"",descriptionPred:""}],
      preventivo: [{authorization_matrix_task_id:"",km:"", ammount:"", month: "", role:"",task:"",taskLabel:"",description:""}],
      correctivo: [{authorization_matrix_task_id:"",ammountCorr:"", roleCorr:"",descriptionCorr:""}],
      siniestros: [{authorization_matrix_task_id:"",ammountSin:"", roleSin:"",descriptionSin:""}],
      otros: [{authorization_matrix_task_id:"",kmOtros:"", ammountOtros:"", monthOtros: "", roleOtros:"",taskOtros:"", taskLabel:"", descriptionOtros:""}],
      matrixName: "",
      description:"",
      tasks:{},
      idContract: "",
      idMatrix: "",
      action:"",
      dialogOpen: false,
      disabled:false,
      files: [],
      media:[],
      loading: true, 
      tasks_to_delete:[]
    }
      
  }

  async componentDidMount() {
    let predictivo = [];
    var result = await this.getPredictivoTasks().then(result=> result.map((val, idx) => {
      predictivo.push({authorization_matrix_task_id:"",kmPred:"", ammountPred:"", monthPred: "", rolePred:"",taskPred:val.id,taskLabel:val.name,descriptionPred:""})  
    }))

    let otros = [];
    var result = await this.getOtrosTasks().then(result=> result.map((val, idx) => {
      otros.push({authorization_matrix_task_id:"",kmPred:"", ammountPred:"", monthPred: "", rolePred:"",taskPred:val.id,taskLabel:val.name,descriptionPred:""})  
    }))


    result = await this.getTasks().then(result=> result.map((val, idx) => {
      /*if (val.name === 'PREDICTIVO'){
//        predictivo.push({authorization_matrix_task_id:"",kmPred:"", ammountPred:"", monthPred: "", rolePred:"",taskPred:val.id,taskLabel:val.name,descriptionPred:""})  
        val.children.map((val2, idx2) => {
            if (val2.children.length){
              val2.children.map((val3, idx3)=>{
                if (val3.category_id === val.category_id && val3.name !== val2.name){
                  predictivo.push({authorization_matrix_task_id:"",kmPred:"", ammountPred:"", monthPred: "", rolePred:"",taskPred:val3.id,taskLabel:val3.name,descriptionPred:""})
                }
              })
            } else {
              if (val2.category_id === val.category_id){
                predictivo.push({authorization_matrix_task_id:"",kmPred:"", ammountPred:"", monthPred: "", rolePred:"",taskPred:val2.id,taskLabel:val2.name,descriptionPred:""})
              }
            }
        })
      } else */
      if (val.name == 'SINIESTROS'){
          this.setState({idSiniestros: val.id})
      } else if (val.name =='CORRECTIVO'){
          this.setState({idCorrectivo: val.id})
      } else if  (val.name == 'PREVENTIVO'){
          this.setState({idPreventivo: val.id})
      }
      this.setState({tasks: result}); 
    }))
    this.setState({predictivo: predictivo, otros: otros});
    await this.getParams();
    this.setState({loading: false})

  }
  
  getParams(location) {
    const searchParams = new URLSearchParams(window.location.search);
    if (searchParams.get("idContract")){
        this.setState({action: 'new'})
        this.setState({idContract: searchParams.get("idContract")})  
    } else if (searchParams.get("idMatrix")) {
        this.setState({action: 'edit'})
        this.setState({idMatrix: searchParams.get("idMatrix")})  
        this.setMatrix(searchParams.get("idMatrix"));
    } else if (searchParams.get("vMatrix")){
        this.setState({action: 'view'})
        this.setState({idMatrix: searchParams.get("vMatrix")})  
        this.setMatrix(searchParams.get("vMatrix"));     
        this.setState({disabled: true}) 
    }
    return; 
  }

  setMatrix(idMatrix){
    //let {preventivo, correctivo, siniestros, otros } = this.state
    var preventivo = []
    var predictivo = []
    var correctivo = []
    var siniestros = []
    var otros = []
    var media=[];

    const result = this.getMatrix(idMatrix).then(result =>
      {
        var promise = new Promise(function(resolve, reject) {
          resolve(result);
          media = result.media
          let matrixTasks = result.tasks
          matrixTasks.map((val, idx) => {
            if (typeof val.description === null || typeof val.description === undefined || val.description === 'null' || val.description ==='undefined'){
              val.description =''
            }
            val.task.task.category.name = val.task.task.category.name.toUpperCase();
            val.task.unit.name = val.task.unit.name.toUpperCase();
            if (val.task.task.category.name == 'OTROS' || val.task.task.category.name =='GESTORIA' ||  val.task.task.category.name === 'OTROS CUSTOM MATRIZ'){
                if (val.task.task.name === 'SINIESTROS'){
                    siniestros.push({authorization_matrix_task_id:val.id, ammountSin: val.value, taskLabel: val.task.task.name, taskSin: val.task.task.id, roleSin: val.role_id, descriptionSin: val.description})
                } else {
                if (val.task.unit.name === 'KM'){
                  otros.push({authorization_matrix_task_id:val.id,kmOtros: val.value, taskLabel: val.task.task.name, taskOtros: val.task.task.id, roleOtros: val.role_id, descriptionOtros: val.description})
                } else if (val.task.unit.name === 'MESES') {
                  otros.push({authorization_matrix_task_id:val.id,monthOtros: val.value, taskLabel: val.task.task.name, taskOtros: val.task.task.id, roleOtros: val.role_id, descriptionOtros: val.description})
                } else if (val.task.unit.name === 'MONTO') {
                  otros.push({authorization_matrix_task_id:val.id,ammountOtros: val.value, taskLabel: val.task.task.name, taskOtros: val.task.task.id, roleOtros: val.role_id, descriptionOtros: val.description})
                }

              }
            } else if (val.task.task.category.name === 'MANTENIMIENTO PREDICTIVO' || val.task.task.category.name === 'PREDICTIVO CUSTOM MATRIZ') {
                
              if (val.task.unit.name === 'KM'){
                predictivo.push({authorization_matrix_task_id:val.id,kmPred: val.value, taskLabel: val.task.task.name, taskPred: val.task.task.id, rolePred: val.role_id, descriptionPred: val.description})
              } else if (val.task.unit.name === 'MESES') {
                predictivo.push({authorization_matrix_task_id:val.id,monthPred: val.value, taskLabel: val.task.task.name, taskPred: val.task.task.id, rolePred: val.role_id, descriptionPred: val.description})
              } else if (val.task.unit.name === 'MONTO') {
                predictivo.push({authorization_matrix_task_id:val.id,ammountPred: val.value, taskLabel: val.task.task.name, taskPred: val.task.task.id, rolePred: val.role_id, descriptionPred: val.description})
              }

            }  else if (val.task.task.category.name === 'MANTENIMIENTO PREVENTIVO') {
                preventivo.push({authorization_matrix_task_id:val.id, ammount: val.value, taskLabel: val.task.task.name, task: val.task.task.id, role: val.role_id, description: val.description})

            } else if (val.task.task.category.name === 'MANTENIMIENTO CORRECTIVO'){
                correctivo.push({authorization_matrix_task_id:val.id,ammountCorr: val.value, taskLabel: val.task.task.name, taskCorr: val.task.task.id, roleCorr: val.role_id, descriptionCorr: val.description})
            } 
          })
      })

      this.setState({media: media})
      predictivo.length ? this.setState({predictivo: predictivo}) : predictivo = []
      siniestros.length ? this.setState({siniestros: siniestros}) : siniestros = []
      otros.length ? this.setState({otros: otros.sort()}) : otros = []
      preventivo.length ? this.setState({preventivo: preventivo}) : preventivo = []
      correctivo.length ? this.setState({correctivo: correctivo.sort()}) : correctivo = []

//      this.setState({otros: otros.sort()});
//      this.setState({preventivo: preventivo.sort()});
//      this.setState({correctivo: correctivo.sort()});


          
      }
    );
   
  }

  getMatrix(idMatrix){
    const token =localStorage.getItem('userToken')

    return axios
         .get(api.authorization_matrix().get(idMatrix),{ headers: {"Authorization" : `Bearer ${token}`} })
          .then(res => {
              this.setState({matrixName: res.data.name})
              this.setState({description: (res.data.description !== null) ? res.data.description : '' })
              this.setState({idContract: (res.data.contract) ? res.data.contract.id : 0})
//              this.setState({tasks: Object.values(res.data)})
              res.data = res.data;
              return res.data
          })
          .catch(err =>{console.log(err)
          })
  }

  getTasks= () => {
    const token =localStorage.getItem('userToken')

    return axios
         .get(api.authorization_matrices_tasks,{ headers: {"Authorization" : `Bearer ${token}`} })
          .then(res => {
              res.data = Object.values(res.data);
              return res.data
          })
          .catch(err =>{console.log(err)
          })
  }
  getPredictivoTasks= () => {
    const token =localStorage.getItem('userToken')

    return axios
         .get(api.categories().get('9'),{ headers: {"Authorization" : `Bearer ${token}`} })
          .then(res => {
              res.data = Object.values(res.data);
              return res.data
          })
          .catch(err =>{console.log(err)
          })
  }

  getOtrosTasks= () => {
    const token =localStorage.getItem('userToken')

    return axios
         .get(api.categories().get('10'),{ headers: {"Authorization" : `Bearer ${token}`} })
          .then(res => {
              res.data = Object.values(res.data);
              return res.data
          })
          .catch(err =>{console.log(err)
          })
  }

  handleFileChange= e => {
    this.setState({
      files: e.target.files[0],
    })

  }

  handleChangeForm = (e) => {
    var res = e.target.id.split("-");

    const section = res[0];
    const varName =res[1];
    const id =res[2];
    if (section ==='predictivo'){
       if (["kmPred", "ammountPred", "monthPred", "rolePred", "taskPred", "descriptionPred"].includes(varName)) {
          //let preventivo = [...this.state.preventivo]
          let predictivoCopy = JSON.parse(JSON.stringify(this.state.predictivo))
          if (['ammountPred'].includes(varName)){
            predictivoCopy[id][varName] = e.target.value.replace('$','')
          } else {
            predictivoCopy[id][varName] = e.target.value.toUpperCase()
          }
          this.setState({ predictivo: predictivoCopy})
  
          //this.setState({[preventivo[id][varName]]: e.target.value})
        } 
    }
    
    if (section ==='preventivo'){
        if (["km", "ammount", "month", "role", "task", "description"].includes(varName)) {
          //let preventivo = [...this.state.preventivo]
          let preventivoCopy = JSON.parse(JSON.stringify(this.state.preventivo))
          if(["ammount"].includes(varName)){
            preventivoCopy[id][varName] = e.target.value.replace('$','')
          } else {
            preventivoCopy[id][varName] = e.target.value.toUpperCase()
          }
  
          this.setState({ preventivo: preventivoCopy})
        } 
    } else if (section ==='correctivo'){
        if (["ammountCorr",  "roleCorr",, "descriptionCorr"].includes(varName)) {
          /*let correctivo = [...this.state.correctivo]
          correctivo[id][varName] = e.target.value.toUpperCase()
          this.setState({ correctivo }, () => console.log(this.state.correctivo))*/
          let correctivoCopy = JSON.parse(JSON.stringify(this.state.correctivo))
          if (['ammountCorr'].includes(varName)){
            correctivoCopy[id][varName] = e.target.value.replace('$','')
          } else {
            correctivoCopy[id][varName] = e.target.value.toUpperCase()
          }

          this.setState({ correctivo: correctivoCopy})
        } 
    } else if (section==='otros'){
        if (["kmOtros", "ammountOtros", "monthOtros", "roleOtros", "taskOtros", "descriptionOtros"].includes(varName)) {
          /*let otros = [...this.state.otros]
          otros[id][varName] = e.target.value.toUpperCase()
          this.setState({ otros }, () => console.log(this.state.otros))*/
          let otrosCopy = JSON.parse(JSON.stringify(this.state.otros))
          if (['ammountOtros'].includes(varName)){
            otrosCopy[id][varName] = e.target.value.replace('$','')
          } else {
            otrosCopy[id][varName] = e.target.value.toUpperCase()
          }
          this.setState({ otros: otrosCopy})
        } 
    }  else if (section ==='siniestros'){
        if (["ammountSin",  "roleSin",, "descriptionSin"].includes(varName)) {
          /*let siniestros = [...this.state.siniestros]
          siniestros[id][varName] = e.target.value.toUpperCase()
          this.setState({ siniestros }, () => console.log(this.state.siniestros))*/
          let siniestrosCopy = JSON.parse(JSON.stringify(this.state.siniestros))
          if (['ammountSin'].includes(varName)){
            siniestrosCopy[id][varName] = e.target.value.replace('$','')
          } else {
            siniestrosCopy[id][varName] = e.target.value.toUpperCase()
          }

          this.setState({ siniestros: siniestrosCopy})          
        } 
    }

    if(e.target.name ==='matrixName'){
      this.setState({ matrixName: e.target.value })
    }
    if (e.target.name==='description'){
      this.setState({ description: e.target.value })
    }

  }

  duplicateRowPredictivo = idx => () => {
    this.setState((prevState) => ({
      predictivo: [...prevState.predictivo, this.state.predictivo[idx]],
    }));
  }

  duplicateRowPreventivo = idx => () => {
    this.setState((prevState) => ({
      preventivo: [...prevState.preventivo, this.state.preventivo[idx]],
    }));
  }

  duplicateRowCorrectivo = idx => () => {
    this.setState((prevState) => ({
      correctivo: [...prevState.correctivo, this.state.correctivo[idx]],
    }));
  }
  
  duplicateRowOtros = idx => () => {
    this.setState((prevState) => ({
      otros: [...prevState.otros, this.state.otros[idx]],
    }));
  }
  
  duplicateRowSiniestros = idx => () => {
    this.setState((prevState) => ({
      siniestros: [...prevState.siniestros, this.state.siniestros[idx]],
    }));
  }

  addNewItemPreventivo = (e) => {
    this.setState((prevState) => ({
      preventivo: [...prevState.preventivo, {authorization_matrix_task_id:"",km:"", ammount:"", month: "", role:"",task:this.state.idPreventivo}],
    }));
  }

  removeItemPreventivo = idx => () => {
    var preventivo = this.state.preventivo 
    var task = preventivo[idx]
    var tasks_to_delete = this.state.tasks_to_delete
    task.task_id = task.task
    task.role_id = task.role
    task.unit_id = 3
    task.value = task.ammount

    tasks_to_delete.push(task)
    this.setState({tasks_to_delete: tasks_to_delete})

    this.setState((prevState) => ({
      preventivo: [...prevState.preventivo.filter((s, sidx) => idx !== sidx)],
    }));
  }

  addNewItemPredictivo = (e) => {
    this.setState((prevState) => ({
      predictivo: [...prevState.predictivo, {authorization_matrix_task_id:"",kmPred:"", ammountPred:"", monthPred: "", rolePred:"",taskPred:""}],
    }));
  }

  removeItemPredictivo = idx => () => {
    var predictivo = this.state.predictivo 
    var task = predictivo[idx]
    var tasks_to_delete = this.state.tasks_to_delete
    task.task_id = task.taskPred
    task.role_id = task.rolePred
    task.unit_id = (task.kmPred) ? 1 : (task.ammountPred) ? 3 : 2
    task.value = (task.kmPred) ? task.kmPred : (task.ammountPred) ? task.ammountPred : task.monthPred


    tasks_to_delete.push(task)
    this.setState({tasks_to_delete: tasks_to_delete})

    this.setState((prevState) => ({
      predictivo: [...prevState.predictivo.filter((s, sidx) => idx !== sidx)],
    }));


  }

  addNewItemCorrectivo = (e) => {

    this.setState((prevState) => ({
      correctivo: [...prevState.correctivo, {authorization_matrix_task_id:"",ammountCorr:"", roleCorr:""}],
    }));
  }

  removeItemCorrectivo = idx => () => {
    var correctivo = this.state.correctivo 
    var task = correctivo[idx]
    var tasks_to_delete = this.state.tasks_to_delete
    task.task_id = task.taskCorr
    task.role_id = task.roleCorr
    task.unit_id = 3
    task.value = task.ammountOtros

    tasks_to_delete.push(task)
    this.setState({tasks_to_delete: tasks_to_delete})

    this.setState((prevState) => ({
      correctivo: [...prevState.correctivo.filter((s, sidx) => idx !== sidx)],
    }));
  }


  addNewItemSiniestros = (e) => {
    this.setState((prevState) => ({
      siniestros: [...prevState.siniestros, {authorization_matrix_task_id:"",ammountSin:"", roleSin:"", descriptionSin:""}],
    }));
  }

  removeItemSiniestros = idx => () => {
    var siniestros = this.state.siniestros 
    var task = siniestros[idx]
    var tasks_to_delete = this.state.tasks_to_delete
    task.task_id = task.taskSin
    task.role_id = task.roleSin
    task.unit_id = 3
    task.value = task.ammountSin

    tasks_to_delete.push(task)
    this.setState({tasks_to_delete: tasks_to_delete})

    this.setState((prevState) => ({
      siniestros: [...prevState.siniestros.filter((s, sidx) => idx !== sidx)],
    }));
  }

  addNewItemOtros = (e) => {
    this.setState((prevState) => ({
      otros: [...prevState.otros, {authorization_matrix_task_id:"",kmOtros:"", ammountOtros:"", monthOtros: "", roleOtros:"",taskOtros:"", descriptionOtros:""}],
    }));
  }

  removeItemOtros = idx => () => {
    var otros = this.state.otros 
    var task = otros[idx]
    var tasks_to_delete = this.state.tasks_to_delete
    task.task_id = task.taskOtros
    task.role_id = task.roleOtros
    task.unit_id = (task.kmOtros) ? 1 : (task.ammountOtros) ? 3 : 2
    task.value = (task.kmOtros) ? task.kmOtros : (task.ammountOtros) ? task.ammountOtros : task.monthOtros

    tasks_to_delete.push(task)
    this.setState({tasks_to_delete: tasks_to_delete})

    this.setState((prevState) => ({
      otros: [...prevState.otros.filter((s, sidx) => idx !== sidx)],
    }));
  }
  
  handlePreview = (e) => {
    let matrix_id = this.state.idMatrix
    const token =localStorage.getItem('userToken')

    return axios
         .get(api.authorization_matrix().preview(matrix_id),{ headers: {"Authorization" : `Bearer ${token}`} })
          .then(res => {
                this.setState({errors: true})
                this.setState({message: res.data})
                this.setState({dialogOpen: true})
              return true
            })
          .catch(err =>{console.log(err)
          })
  }
  
  handleSubmit = (e) => {
    const tasks=[]

    this.state.otros.map((val, idx) => {
        let task_id = val.taskOtros;
        if (val.kmOtros){
            tasks.push({'authorization_matrix_task_id':val.authorization_matrix_task_id,'task_id':task_id, 'unit_id':1,'task_state_id':1, 'value':val.kmOtros, 'role_id':val.roleOtros, 'description': val.descriptionOtros})
        }
        if (val.monthOtros){
            tasks.push({'authorization_matrix_task_id':val.authorization_matrix_task_id,'task_id':task_id, 'unit_id':2,'task_state_id':1,'value':val.monthOtros, 'role_id':val.roleOtros, 'description': val.descriptionOtros})
        }
        if (val.ammountOtros){
            tasks.push({'authorization_matrix_task_id':val.authorization_matrix_task_id,'task_id':task_id, 'unit_id':3,'task_state_id':1,'value':val.ammountOtros, 'role_id':val.roleOtros, 'description': val.descriptionOtros})
        }
    })

    this.state.preventivo.map((val, idx) => {
        if (val.ammount){
            tasks.push({'authorization_matrix_task_id':val.authorization_matrix_task_id,'task_id':this.state.idPreventivo, 'unit_id':3,'task_state_id':1,'value': val.ammount, 'role_id':val.role, 'description': val.description})
        }
    })

    this.state.correctivo.map((val, idx) => {
        if (val.ammountCorr){
            tasks.push({'authorization_matrix_task_id':val.authorization_matrix_task_id,'task_id':this.state.idCorrectivo, 'unit_id':3,'task_state_id':1,'value':val.ammountCorr, 'role_id':val.roleCorr, 'description': val.descriptionCorr})
        }
    })

    this.state.siniestros.map((val, idx) => {
        if (val.ammountSin){
            tasks.push({'authorization_matrix_task_id':val.authorization_matrix_task_id,'task_id':this.state.idSiniestros, 'unit_id':3,'task_state_id':1,'value':val.ammountSin, 'role_id':val.roleSin, 'description': val.descriptionSin})
        }
    })

    this.state.predictivo.map((val, idx) => {
        let task_id = val.taskPred;
        if (val.kmPred){
            tasks.push({'authorization_matrix_task_id':val.authorization_matrix_task_id,'task_id':task_id, 'unit_id':1,'task_state_id':1,'value':val.kmPred, 'role_id':val.rolePred, 'description': val.descriptionPred})
        }
        if (val.monthPred){
            tasks.push({'authorization_matrix_task_id':val.authorization_matrix_task_id,'task_id':task_id, 'unit_id':2,'task_state_id':1,'value':val.monthPred, 'role_id':val.rolePred, 'description': val.descriptionPred})
        }
        if (val.ammountPred){
            tasks.push({'authorization_matrix_task_id':val.authorization_matrix_task_id,'task_id':task_id, 'unit_id':3,'task_state_id':1,'value':val.ammountPred, 'role_id':val.rolePred, 'description': val.descriptionPred})
        }
    })
    var formData = new FormData();
    var i =0;
    tasks.map((val, idx)=>{
        if (val.authorization_matrix_task_id >0){
          if (val.description === null || val.description === undefined) {
            val.description = ''
          }
          formData.set('authorization_matrix[tasks]['+i+'][id]', val.authorization_matrix_task_id)
          formData.set('authorization_matrix[tasks]['+i+'][task_id]', val.task_id)
          formData.set('authorization_matrix[tasks]['+i+'][unit_id]', val.unit_id)
          formData.set('authorization_matrix[tasks]['+i+'][task_state_id]', val.task_state_id)
          formData.set('authorization_matrix[tasks]['+i+'][value]', val.value)
          formData.set('authorization_matrix[tasks]['+i+'][role_id]',val.role_id)
          formData.set('authorization_matrix[tasks]['+i+'][description]', val.description)
          i++
         
        } else if (val.task_id > 0){
          formData.set('authorization_matrix[tasks]['+i+'][task_id]', val.task_id)
          formData.set('authorization_matrix[tasks]['+i+'][unit_id]', val.unit_id)
          formData.set('authorization_matrix[tasks]['+i+'][task_state_id]', val.task_state_id)
          formData.set('authorization_matrix[tasks]['+i+'][value]', val.value)
          formData.set('authorization_matrix[tasks]['+i+'][role_id]',val.role_id)
          formData.set('authorization_matrix[tasks]['+i+'][description]', val.description)
          i++
        }
    })
    this.state.tasks_to_delete.map((val, idx)=>{
        if (val.authorization_matrix_task_id > 0){
            if (val.description === null || val.description === undefined) {
              val.description = ''
            }

            formData.set('authorization_matrix[tasks]['+i+'][id]', val.authorization_matrix_task_id)
            formData.set('authorization_matrix[tasks]['+i+'][deleted_at]', Date.now())
            formData.set('authorization_matrix[tasks]['+i+'][task_id]', val.task_id)
            formData.set('authorization_matrix[tasks]['+i+'][unit_id]', val.unit_id)
            formData.set('authorization_matrix[tasks]['+i+'][task_state_id]', 1)
            formData.set('authorization_matrix[tasks]['+i+'][value]', (val.value) ? val.value : 0)
            formData.set('authorization_matrix[tasks]['+i+'][role_id]',val.role_id)
            formData.set('authorization_matrix[tasks]['+i+'][description]', val.description)
            i++
        }
    })

    if (i==0){
      formData.set('authorization_matrix[tasks]',[])
    }
    formData.set('authorization_matrix[name]', this.state.matrixName)
    if (this.state.description === ''){
      formData.set('authorization_matrix[description]', '')
    } else {
      formData.set('authorization_matrix[description]', this.state.description)
      
    }
    if (this.state.idContract !== '0'){
      formData.set('authorization_matrix[contract_id]', (this.state.idContract !== '0') ? this.state.idContract : '')
    }

    this.state.files.map((val, idx) => {
      formData.append(`media[${idx}]`, val)
    })
    
    var errors = false
    this.setState({errors: errors})
    var self = this
    const token =localStorage.getItem('userToken')

    if (this.state.action === 'new'){
//      let request =  JSON.stringify({'contract_id':this.state.idContract,'name':this.state.matrixName,'description':this.state.description,'tasks' : tasks,'files': this.state.files});
      axios.post(api.authorization_matrix().post(),
         formData,
         {headers: {'Content-Type': 'multipart/form-data',"Authorization" : `Bearer ${token}`}}
         )
        .then((response)=> {
            this.setState({dialogOpen: true});
            this.setState({message: 'Matriz creada con éxito'})
        })
        .catch((error) => {
            self.setState({errors: true})
            self.setState({message: 'Faltan cargar los roles. Por favor revisar.'})
            self.setState({dialogOpen: true})
      })


      e.preventDefault()

    } else {
      formData.set('authorization_matrix[id]', this.state.idMatrix)
      formData.append('_method', 'patch');
      //let request =  JSON.stringify({'contract_id':this.state.idContract,'matrix_id': this.state.idMatrix,'name':this.state.matrixName,'description':this.state.description,'tasks' : tasks,'files': this.state.files});
      axios.post(api.authorization_matrix().patch(this.state.idMatrix),
         formData,
         {headers: {'Content-Type': 'multipart/form-data',"Authorization" : `Bearer ${token}`}}
         )
        .then((response)=> {
            this.setState({dialogOpen: true});
            this.setState({message: 'Matriz modificada con éxito'})
        })
        .catch(function (error) {
            self.setState({errors: true})
            self.setState({message: 'Faltan cargar los roles. Por favor revisar.'})
            self.setState({dialogOpen: true})
      })
      e.preventDefault()
    }
  }


  handleChange = panel => (event, isExpanded) => {
    if (this.state.expanded === panel) {
      this.setState({expanded: false});
    } else {
      this.setState({expanded: panel})
    };
    
  }
  
  handleUpload(files){
    this.setState({
      files: files
    });
  }
 

  setTask(idx,e){

    var res = idx.split("-");

    const section = res[0];
    const varName =res[1];
    const id =res[2];
    if (section ==='predictivo'){
        if (["kmPred", "ammountPred", "monthPred", "rolePred", "taskPred"].includes(varName)) {
          let predictivo = [...this.state.predictivo]
          predictivo[id][varName] = e.value
          if (varName==='taskPred'){
            predictivo[id]['taskLabel'] = e.label
          }
          this.setState({ predictivo }, () => console.log(this.state.predictivo))
        } 
    } else if (section ==='correctivo'){
        if (["ammountCorr",  "roleCorr"].includes(varName)) {
          let correctivo = [...this.state.correctivo]
          correctivo[id][varName] = e.value
          this.setState({ correctivo }, () => console.log(this.state.correctivo))
        } 
     } else if (section ==='preventivo'){
        if (["ammount",  "role"].includes(varName)) {
          let preventivo = [...this.state.preventivo]
          preventivo[id][varName] = e.value
          this.setState({ preventivo }, () => console.log(this.state.preventivo))
        }
      } else if (section ==='otros'){
        if (["kmOtros", "ammountOtros", "monthOtros", "roleOtros", "taskOtros"].includes(varName)) {
          let otros = [...this.state.otros]
          otros[id][varName] = e.value
          if (varName==='taskOtros'){
            otros[id]['taskLabel'] = e.label
          }
          this.setState({ otros }, () => console.log(this.state.otros))
        } 
    } 
  }
      
    render() {
      const handleDownload = id => () => {
        console.log(id)
      }
      
      const handleRedirect = id=> () =>{
        window.location.href=`/authorizationMatrices?idContract=${id}`
      }

      const handleDialogClose = () => {
        this.setState({dialogOpen: false})
      }

      let {preventivo, predictivo, correctivo, siniestros, otros, description, matrixName, media} = this.state

      const useStyles = (theme) => makeStyles(theme => ({
        root: {
          width: '100%',
        },
        heading: {
          fontSize: theme.typography.pxToRem(15),
          flexBasis: '33.33%',
          flexShrink: 0,
        },
         formControl: {
          margin: theme.spacing(1),
          minWidth: 120,
        },
        textField: {
          marginLeft: theme.spacing(1),
          marginRight: theme.spacing(1),
        },
        secondaryHeading: {
          fontSize: theme.typography.pxToRem(15),
          color: theme.palette.text.secondary,
        },
        label: {
          fontSize: theme.typography.pxToRem(13),
          color: theme.palette.text.secondary,
        },
        iconButton: {
          color: 'red'
        }
      }));

      const onChange = (currentNode, selectedNodes) => {
        console.log('onChange::', currentNode, selectedNodes)
      }
      const onAction = (node, action) => {
        console.log('onAction::', action, node)
      }
      const onNodeToggle = currentNode => {
        console.log('onNodeToggle::', currentNode)
      }

     const data = this.state.tasks;
     const classes = useStyles();
     return (
          (this.state.loading)?
               <LinearProgress /> 
            :
          <form onSubmit={this.handleSubmit} onChange={this.handleChangeForm} >

          <Dialog
            open={this.state.dialogOpen}
            fullWidth
            aria-labelledby="responsive-dialog-title"
          >
            <DialogTitle id="responsive-dialog-title">{"Matriz de autorización"}</DialogTitle>
            <DialogContent>
              <DialogContentText>
                  <div dangerouslySetInnerHTML={{ __html: this.state.message }}></div>
              </DialogContentText>
            </DialogContent>
            <DialogActions disableSpacing="false">  
              {(this.state.errors) ?
                <Button onClick={handleDialogClose} variant="contained" color="primary" >
                    Aceptar
                </Button>
                :
                <Button onClick={handleRedirect(this.state.idContract)} variant="contained" color="primary" >
                    Aceptar
                </Button>
               }
            </DialogActions>
          </Dialog>

          <TextField
            disabled={this.state.disabled}
            id="matrixName"
            placeholder="Ingrese un nombre de matriz de autorización"
            fullWidth
            required
            value={matrixName}
            name="matrixName"
            margin="normal"
            InputLabelProps={{
              shrink: true,
            }}
          />

          <ExpansionPanel expanded={this.state.expanded === 'panel1'} onChange={this.handleChange('panel1')}>
          <ExpansionPanelSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <Typography className={classes.heading}>Plan preventivo</Typography>
            <Typography className={classes.secondaryHeading}></Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <Typography>
              De acuerdo al plan de servicio del fabricante
            { preventivo.map((val, idxPreve) => {
            let ammountId = `ammount-${idxPreve}`, roleId = `role-${idxPreve}`, descriptionId = `description-${idxPreve}` 
            return (

            <div key={idxPreve}>
              <NumberFormat label="Monto"
                            disabled={this.state.disabled}
                            className="ammount m-2"
                            InputProps={{style: {width: '5rem', fontSize: '0.75rem'}}}
                            name={ammountId}
                            data-id={idxPreve}
                            id={`preventivo-${ammountId}`}
                            value={preventivo[idxPreve].ammount}
                            thousandSeparator='.'
                            decimalSeparator=','
                            prefix={'$'}
                            customInput={TextField}  
                            InputLabelProps={{
                              shrink: true,
                            }}
                            isAllowed={(values) => {
                                const { formattedValue, floatValue } = values;
                                return formattedValue === "" || floatValue >= 1;
                            }}
              />
            <FormControl className="m-2" style={{minWidth: 150, fontSize: '0.75rem'}} 
              error= {(preventivo[idxPreve].ammount > 0 && preventivo[idxPreve].role === '' ) ? true : false}
              >
              <InputLabel htmlFor="grouped-native-select"  autoWidth="true" style={{minWidth: 150, fontSize: '0.75rem'}} >Selecione el rol</InputLabel>
              <Select native defaultValue=""
              disabled={this.state.disabled}

               inputProps={{
                    name:roleId,
                    dataid:idxPreve,
                    id:`preventivo-${roleId}`,
                    className:"role"
                  }}
               style={{minWidth: 150, fontSize: '0.75rem'}}
               id={`preventivo-$roleId`}
               value={preventivo[idxPreve].role}
               input={<Input id="grouped-native-select" />}>
                <option value="" />             
                <optgroup label="AutoCorp">
                  <option value="4">AutoCorp Verificador</option>
                  <option value="5">AutoCorp Aprobador</option>
                  <option value="6">AutoCorp Aprobador + 1</option>
                </optgroup>
                <optgroup label="Cliente">
                  <option value="1">Cliente Verificador</option>
                  <option value="2">Cliente Aprobador</option>
                  <option value="3">Cliente Aprobador + 1</option>
                </optgroup>
              </Select>
            </FormControl>
            <Tooltip title={preventivo[idxPreve].description} aria-label="add">
            <TextField
                disabled={this.state.disabled}
                label="Comentarios"
                type="text"
                className="m-2"
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{style: {width: '15rem', fontSize: '0.75rem'}}}
                inputProps={{
                  min: 1,
                  id:`preventivo-${descriptionId}`,
                  className:"description"
                }}
                id={`preventivo-${descriptionId}`}
                value={preventivo[idxPreve].description}
                margin="normal"
              />
              </Tooltip>
              {(this.state.disabled===false)? (
                <div class="mt-4" style={{width:"min-content", display:"inline-flex"}}>   
                
                  <IconButton size="small" className={classes.iconButton} onClick={this.removeItemPreventivo(idxPreve)}
                  disabled={(preventivo.length ==1) ? true : false} >
                    <RemoveIcon className={classes.deleteIcon} />
                  </IconButton>
                  <IconButton size="small" className={classes.iconButton} onClick={this.addNewItemPreventivo}>
                        <AddIcon className={classes.deleteIcon}/>
                  </IconButton>
                  <IconButton size="small" className={classes.iconButton} onClick={this.duplicateRowPreventivo(idxPreve)} >
                    <ControlPointDuplicateIcon className={classes.deleteIcon} />
                  </IconButton>  
                </div>
                ):''}
            </div>
                )}
            )} 

            </Typography>
          </ExpansionPanelDetails>
        </ExpansionPanel>

        <ExpansionPanel expanded={this.state.expanded === 'panel2'} onChange={this.handleChange('panel2')}>
          <ExpansionPanelSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2bh-content"
            id="panel2bh-header"
          >
            <Typography className={classes.heading}>Plan predictivo</Typography>
            <Typography className={classes.secondaryHeading}></Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
          <Typography variant="caption">
          { predictivo.map((val, idxPred) => {
            let kmPredId = `kmPred-${idxPred}`, ammountPredId = `ammountPred-${idxPred}` , taskPredId = `taskPred-${idxPred}` , rolePredId = `rolePred-${idxPred}` , monthPredId = `monthPred-${idxPred}`, descriptionPredId = `descriptionPred-${idxPred}`
            return(
            <div key={idxPred}>
           {predictivo[idxPred].taskPred ==='' ? (
            <DropdownTreeSelect 
                                disabled={this.state.disabled}
                                data={data} onChange={e => {onChange(e);this.setTask(`predictivo-${taskPredId}`,e)}}
                                onAction={onAction} onNodeToggle={onNodeToggle}
                                mode="radioSelect"
                                className="mt-4"
                                texts={{ placeholder: 'Buscar tareas' }}                                 
                                style={{display: "inline-block"}}/>
            ):''}
            {predictivo[idxPred].taskPred !=='' ? (
            <TextField disabled id={`predictivo-${taskPredId}`} className="mt-4" value={predictivo[idxPred].taskLabel} InputProps={{style: {width: '10rem', fontSize: '0.75rem'}}} />
            ):''}
            <TextField
                  label="KM"
                  type="number"
                  className="m-2"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  disabled={this.state.disabled}
                  InputProps={{style: {width: '5rem', fontSize: '0.75rem'}}}
                  inputProps={{
                    min: 1,
                    id:`predictivo-${kmPredId}`,
                    className:"km"
                  }}
                  id={`predictivo-${kmPredId}`}
                  value={predictivo[idxPred].kmPred}
                  margin="normal"
                />
              <TextField
                  label="Meses"
                  disabled={this.state.disabled}
                  inputProps={{
                    min: 1,
                    name:monthPredId,
                    dataid:idxPred,
                    id:`predictivo-${monthPredId}`,
                    className:"month"
                  }}
                  value={predictivo[idxPred].monthPred}
                  InputProps={{style: {width: '5rem', fontSize: '0.75rem'}}}
                  type="number"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  className="m-2"
                  margin="normal"
                />
              <NumberFormat label="Monto"
                            disabled={this.state.disabled}
                            className="ammount m-2"
                            InputProps={{style: {width: '5rem', fontSize: '0.75rem'}}}
                            name={ammountPredId}
                            data-id={idxPred}
                            id={`predictivo-${ammountPredId}`}
                            value={predictivo[idxPred].ammountPred}
                            thousandSeparator='.'
                            decimalSeparator=','
                            prefix={'$'}
                            customInput={TextField}  
                            InputLabelProps={{
                              shrink: true,
                            }}
                            isAllowed={(values) => {
                                const { formattedValue, floatValue } = values;
                                return formattedValue === "" || floatValue >= 1;
                            }}

               />
                <FormControl className="m-2" style={{minWidth: 150, fontSize: '0.75rem'}} >
                  <InputLabel htmlFor="grouped-native-select" autoWidth="true" style={{minWidth: 150, fontSize: '0.75rem'}} >Selecione el rol</InputLabel>
                  <Select native
                   disabled={this.state.disabled}
                   error= {((predictivo[idxPred].ammountPred > 0 || predictivo[idxPred].kmPred > 0 || predictivo[idxPred].monthPred > 0) && predictivo[idxPred].rolePred === '' ) ? true : false}
                   inputProps={{
                        name:rolePredId,
                        dataid:idxPred,
                        id:`predictivo-${rolePredId}`,
                        className:"role"
                      }}
                      style={{minWidth: 150, fontSize: '0.75rem'}}
                    value={predictivo[idxPred].rolePred}
                    input={<Input id="grouped-native-select" />}>
                    <option value="" />                   
                    <optgroup label="AutoCorp">
                      <option value="4">AutoCorp Verificador</option>
                      <option value="5">AutoCorp Aprobador</option>
                      <option value="6">AutoCorp Aprobador + 1</option>
                    </optgroup>
                    <optgroup label="Cliente">
                      <option value="1">Cliente Verificador</option>
                      <option value="2">Cliente Aprobador</option>
                      <option value="3">Cliente Aprobador + 1</option>
                    </optgroup>
                  </Select>
                </FormControl>

            <Tooltip title={predictivo[idxPred].descriptionPred} aria-label="add">
                <TextField
                  disabled={this.state.disabled}
                  label="Comentarios"
                  type="text"
                  className="m-2"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{style: {width: '15rem', fontSize: '0.75rem'}}}
                  inputProps={{
                    min: 1,
                    id:`predictivo-${descriptionPredId}`,
                    className:"description"
                  }}
                  id={`predictivo-${descriptionPredId}`}
                  value={predictivo[idxPred].descriptionPred}
                  margin="normal"
                />
                </Tooltip>
                {(this.state.disabled===false)? (
                  
                  <div class="mt-4" style={{width:"min-content", display:"inline-flex"}}> 
                    <IconButton size="small" className={classes.iconButton} onClick={this.removeItemPredictivo(idxPred)}
                    disabled={(predictivo.length ==1) ? true : false}>
                      <RemoveIcon className={classes.deleteIcon}/>
                    </IconButton>
                    <IconButton size="small" className={classes.iconButton} onClick={this.addNewItemPredictivo} >
                      <AddIcon className={classes.deleteIcon} />
                    </IconButton>
                    <IconButton size="small" className={classes.iconButton} onClick={this.duplicateRowPredictivo(idxPred)} >
                      <ControlPointDuplicateIcon className={classes.deleteIcon} />
                    </IconButton>
                  </div>
                ):''}
                </div>
                  )}
                )} 
       
            </Typography>
          </ExpansionPanelDetails>
        </ExpansionPanel>

        <ExpansionPanel expanded={this.state.expanded === 'panel3'} onChange={this.handleChange('panel3')}>
          <ExpansionPanelSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel3bh-content"
            id="panel3bh-header"
          >
            <Typography className={classes.heading}>Plan correctivo</Typography>
            <Typography className={classes.secondaryHeading}></Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <Typography>
            { correctivo.map((val, idxCorr) => {
            let ammountCorrId = `ammountCorr-${idxCorr}`, roleCorrId = `roleCorr-${idxCorr}`, descriptionCorrId = `descriptionCorr-${idxCorr}` 
            return (

            <div key={idxCorr}>
              <NumberFormat label="Monto"
                disabled={this.state.disabled}
                className="ammount m-2"
                InputProps={{style: {width: '5rem', fontSize: '0.75rem'}}}
                name={ammountCorrId}
                data-id={idxCorr}
                id={`correctivo-${ammountCorrId}`}
                value={correctivo[idxCorr].ammountCorr}
                thousandSeparator='.'
                decimalSeparator=','
                prefix={'$'}
                customInput={TextField}  
                InputLabelProps={{
                  shrink: true,
                }}
                isAllowed={(values) => {
                    const { formattedValue, floatValue } = values;
                    return formattedValue === "" || floatValue >= 1;
                }}
               />
            <FormControl className="m-2" style={{minWidth: 150, fontSize: '0.75rem'}} >
              <InputLabel htmlFor="grouped-native-select"  autoWidth="true" style={{minWidth: 150, fontSize: '0.75rem'}} >Selecione el rol</InputLabel>
              <Select native defaultValue=""
               error= {((correctivo[idxCorr].ammountCorr > 0 ) && correctivo[idxCorr].roleCorr=== '' ) ? true : false}               disabled={this.state.disabled}
              inputProps={{
                    name:roleCorrId,
                    dataid:idxCorr,
                    id:`correctivo-${roleCorrId}`,
                    className:"roleCorr"
                  }}
               style={{minWidth: 150, fontSize: '0.75rem'}}
               id={`correctivo-$roleCorrId`}
               value={correctivo[idxCorr].roleCorr}
               input={<Input id="grouped-native-select" />}>
                <option value="" />             
                <optgroup label="AutoCorp">
                  <option value="4">AutoCorp Verificador</option>
                  <option value="5">AutoCorp Aprobador</option>
                  <option value="6">AutoCorp Aprobador + 1</option>
                </optgroup>
                <optgroup label="Cliente">
                  <option value="1">Cliente Verificador</option>
                  <option value="2">Cliente Aprobador</option>
                  <option value="3">Cliente Aprobador + 1</option>
                </optgroup>
              </Select>
            </FormControl>
            <Tooltip title={correctivo[idxCorr].descriptionCorr} aria-label="add">
            <TextField
                disabled={this.state.disabled}
                label="Comentarios"
                type="text"
                className="m-2"
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{style: {width: '15rem', fontSize: '0.75rem'}}}
                inputProps={{
                  min: 1,
                  id:`correctivo-${descriptionCorrId}`,
                  className:"description"
                }}
                id={`correctivo-${descriptionCorrId}`}
                value={correctivo[idxCorr].descriptionCorr}
                margin="normal"
              />
              </Tooltip>
              {(this.state.disabled===false)? (

                <div class="mt-4" style={{width:"min-content", display:"inline-flex"}}>   
                  <IconButton size="small" className={classes.iconButton} onClick={this.removeItemCorrectivo(idxCorr)}
                  disabled={(correctivo.length ==1) ? true : false} >
                    <RemoveIcon className={classes.deleteIcon} />
                  </IconButton>
                  <IconButton size="small" className={classes.iconButton} onClick={this.addNewItemCorrectivo}>
                        <AddIcon className={classes.deleteIcon}/>
                  </IconButton>
                  <IconButton size="small" className={classes.iconButton} onClick={this.duplicateRowCorrectivo(idxCorr)} >
                    <ControlPointDuplicateIcon className={classes.deleteIcon} />
                  </IconButton>
                </div>
                ) : ''}

            </div>
                )}
            )} 
          </Typography>
          </ExpansionPanelDetails>
        </ExpansionPanel>

        <ExpansionPanel expanded={this.state.expanded === 'panel4'} onChange={this.handleChange('panel4')}>
          <ExpansionPanelSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel3bh-content"
            id="panel3bh-header"
          >
            <Typography className={classes.heading}>Siniestros</Typography>
            <Typography className={classes.secondaryHeading}></Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <Typography>
            { siniestros.map((val, idxSin) => {
            let ammountSinId = `ammountSin-${idxSin}`, roleSinId = `roleSin-${idxSin}`, descriptionSinId = `descriptionSin-${idxSin}` 
            return (

            <div key={idxSin}>
              <NumberFormat label="Monto"
                disabled={this.state.disabled}
                className="ammount m-2"
                InputProps={{style: {width: '5rem', fontSize: '0.75rem'}}}
                name={ammountSinId}
                data-id={idxSin}
                id={`siniestros-${ammountSinId}`}
                value={siniestros[idxSin].ammountSin}
                thousandSeparator='.'
                decimalSeparator=','
                prefix={'$'}
                customInput={TextField}  
                InputLabelProps={{
                  shrink: true,
                }}
                isAllowed={(values) => {
                    const { formattedValue, floatValue } = values;
                    return formattedValue === "" || floatValue >= 1;
                }}
               />

            <FormControl className="m-2" style={{minWidth: 150, fontSize: '0.75rem'}} >
              <InputLabel htmlFor="grouped-native-select"  autoWidth="true" style={{minWidth: 150, fontSize: '0.75rem'}} >Selecione el rol</InputLabel>
              <Select native defaultValue=""
              disabled={this.state.disabled}
             error= {((siniestros[idxSin].ammountSin > 0 ) && siniestros[idxSin].roleSin=== '' ) ? true : false}
               inputProps={{
                    name:roleSinId,
                    dataid:idxSin,
                    id:`siniestros-${roleSinId}`,
                    className:"roleSin"
                  }}
               style={{minWidth: 150, fontSize: '0.75rem'}}
               id={`siniestros-$roleSinId`}
               value={siniestros[idxSin].roleSin}
               input={<Input id="grouped-native-select" />}>
                <option value="" />             
                <optgroup label="AutoCorp">
                  <option value="4">AutoCorp Verificador</option>
                  <option value="5">AutoCorp Aprobador</option>
                  <option value="6">AutoCorp Aprobador + 1</option>
                </optgroup>
                <optgroup label="Cliente">
                  <option value="1">Cliente Verificador</option>
                  <option value="2">Cliente Aprobador</option>
                  <option value="3">Cliente Aprobador + 1</option>
                </optgroup>
              </Select>
            </FormControl>
            <Tooltip title={siniestros[idxSin].descriptionSin} aria-label="add">
            <TextField
                disabled={this.state.disabled}
                label="Comentarios"
                type="text"
                className="m-2"
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{style: {width: '15rem', fontSize: '0.75rem'}}}
                inputProps={{
                  min: 1,
                  id:`siniestros-${descriptionSinId}`,
                  className:"description"
                }}
                id={`siniestros-${descriptionSinId}`}
                value={siniestros[idxSin].descriptionSin}
                margin="normal"
              />
              </Tooltip>
              {(this.state.disabled===false)? (
                <div class="mt-4" style={{width:"min-content", display:"inline-flex"}}>   
                
                  <IconButton size="small" className={classes.iconButton} onClick={this.removeItemSiniestros(idxSin)}
                  disabled={(siniestros.length ==1) ? true : false} >

                    <RemoveIcon className={classes.deleteIcon} />
                  </IconButton>
                  <IconButton size="small" className={classes.iconButton} onClick={this.addNewItemSiniestros}>
                        <AddIcon className={classes.deleteIcon}/>
                  </IconButton>
                  <IconButton size="small" className={classes.iconButton} onClick={this.duplicateRowSiniestros(idxSin)} >
                    <ControlPointDuplicateIcon className={classes.deleteIcon} />
                  </IconButton>  
                </div>
                ):''}
            </div>
                )}
            )} 
          </Typography>
          </ExpansionPanelDetails>
        </ExpansionPanel>



        <ExpansionPanel expanded={this.state.expanded === 'panel5'} onChange={this.handleChange('panel5')}>
          <ExpansionPanelSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel3bh-content"
            id="panel3bh-header"
          >
            <Typography className={classes.heading}>Otros</Typography>
            <Typography className={classes.secondaryHeading}>

            </Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <Typography variant="caption">
          { otros.map((val, idxOtros) => {
          let kmOtrosId = `kmOtros-${idxOtros}`, ammountOtrosId = `ammountOtros-${idxOtros}` , taskOtrosId = `taskOtros-${idxOtros}` , roleOtrosId = `roleOtros-${idxOtros}` , monthOtrosId = `monthOtros-${idxOtros}`, descriptionOtrosId = `descriptionOtros-${idxOtros}`
          return(

          <div key={idxOtros}>
          {otros[idxOtros].taskOtros ==='' ? (
            <DropdownTreeSelect 
                                disabled={this.state.disabled}
                                data={data} onChange={e => {onChange(e);this.setTask(`otros-${taskOtrosId}`,e)}}
                                onAction={onAction} onNodeToggle={onNodeToggle}
                                mode="radioSelect"
                                className="mt-4"
                                texts={{ placeholder: 'Buscar tareas' }}                                 
                                style={{width: "200px"}}/> 
          ) : '' }
          {otros[idxOtros].taskOtros !=='' ? (
            <TextField disabled id="standard-disabled" InputProps={{style: {width: '10rem', fontSize: '0.75rem'}}} className="mt-4" value={otros[idxOtros].taskLabel} /> 
          ) : '' }

          <TextField
              disabled={this.state.disabled}
              label="KM"
              type="number"
              InputLabelProps={{
                shrink: true,
              }}
              inputProps={{min: 1}}
              InputProps={{style: {width: '5rem', fontSize: '0.75rem'}}}
              name={kmOtrosId}
              data-id={idxOtros}
              id={`otros-${kmOtrosId}`}
              value={otros[idxOtros].kmOtros}
              className={"m-2"}
              margin="normal"
            />
          <TextField
              disabled={this.state.disabled}
              label="Meses"
              type="number"
              inputProps={{min: 1}}
              InputLabelProps={{
                shrink: true,
              }}
              name={monthOtrosId}
              data-id={idxOtros}
              id={`otros-${monthOtrosId}`}
              value={otros[idxOtros].monthOtros}
              InputProps={{style: {width: '5rem', fontSize: '0.75rem'}}}
              className="m-2"
              margin="normal"
            />
              <NumberFormat label="Monto"
                disabled={this.state.disabled}
                className="ammount m-2"
                InputProps={{style: {width: '5rem', fontSize: '0.75rem'}}}
                name={ammountOtrosId}
                data-id={idxOtros}
                id={`otros-${ammountOtrosId}`}
                value={otros[idxOtros].ammountOtros}
                thousandSeparator='.'
                decimalSeparator=','
                prefix={'$'}
                customInput={TextField}  
                InputLabelProps={{
                  shrink: true,
                }}
                isAllowed={(values) => {
                    const { formattedValue, floatValue } = values;
                    return formattedValue === "" || floatValue >= 1;
                }}
               />
              <FormControl className="m-2" style={{minWidth: 150, fontSize: '0.75rem'}} >
              <InputLabel htmlFor="grouped-native-select"  autoWidth="true" style={{minWidth: 150, fontSize: '0.75rem'}}>Selecione el rol</InputLabel>
              <Select native defaultValue=""
               inputProps={{
                    name:roleOtrosId,
                    dataid:idxOtros,
                    id:`otros-${roleOtrosId}`,
                    className:"roleOtros"
                  }}
                disabled={this.state.disabled}
               error= {((otros[idxOtros].ammountOtros > 0 || otros[idxOtros].kmOtros > 0 || otros[idxOtros].monthOtros > 0) && otros[idxOtros].roleOtros === '' ) ? true : false}
               style={{minWidth: 150, fontSize: '0.75rem'}}   
               id={`otros-$roleOtrosId`}
               value={otros[idxOtros].roleOtros}
               input={<Input id="grouped-native-select" />}>
                <option value="" />
                <optgroup label="AutoCorp">
                  <option value="4">AutoCorp Verificador</option>
                  <option value="5">AutoCorp Aprobador</option>
                  <option value="6">AutoCorp Aprobador  + 1</option>
                </optgroup>
                <optgroup label="Cliente">
                  <option value="1">Cliente Verificador</option>
                  <option value="2">Cliente Aprobador</option>
                  <option value="3">Cliente Aprobador + 1</option>
                </optgroup>
              </Select>
            </FormControl>  
            <Tooltip title={otros[idxOtros].descriptionOtros} aria-label="add">
            <TextField
                disabled={this.state.disabled}
                label="Comentarios"
                type="text"
                className="m-2"
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{style: {width: '15rem', fontSize: '0.75rem'}}}
                inputProps={{
                  min: 1,
                  id:`otros-${descriptionOtrosId}`,
                  className:"description"
                }}
                id={`otros-${descriptionOtrosId}`}
                value={otros[idxOtros].descriptionOtros}
                margin="normal"
              />
            </Tooltip>              
              {(this.state.disabled===false)? (

                <div class="mt-4" style={{width:"min-content", display:"inline-flex"}}>   
                  <IconButton size="small" className={classes.iconButton} onClick={this.removeItemOtros(idxOtros)}
                  disabled={(otros.length ==1) ? true : false} >

                      <RemoveIcon className={classes.deleteIcon} />
                    </IconButton>
                    <IconButton size="small" className={classes.iconButton} onClick={this.addNewItemOtros}>
                          <AddIcon className={classes.deleteIcon} />
                    </IconButton>
                    <IconButton size="small" className={classes.iconButton} onClick={this.duplicateRowOtros(idxOtros)} >
                      <ControlPointDuplicateIcon className={classes.deleteIcon} />
                    </IconButton>
                  </div>
                ):''}
                </div>
                  )}
                )} 
          </Typography>
          </ExpansionPanelDetails>
        </ExpansionPanel>
        <TextField
          id="description"
          disabled={this.state.disabled}
          placeholder="Ingrese observaciones"
          fullWidth
          value={description}
          name="description"
          margin="normal"
          InputLabelProps={{
            shrink: true,
          }}
        />  
        {(this.state.disabled===false)? (
          <div style={{width: "30rem"}}>

            <DropzoneArea onChange={this.handleUpload.bind(this)} 
              dropzoneText="Arrastra los archivos aquí o buscalos"
              showPreviews="true"
              showPreviewsInDropzone={false}
              showFileNamesInPreview="true"
              showFileNames="true"
            />
          </div>
        ):''}

        <div className="row"></div>
        {(media.length>0)?(
        <Table aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>Nombre del archivo</TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {media.map((val,idx) => (
                <TableRow key={val.id}>
                  <TableCell>{val.name}</TableCell>
                  <TableCell>
                  <Link href={api.media_download+'/'+val.id}><ArrowDownwardIcon />Descargar</Link>
          </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
            ):''
          }


        {(this.state.action !== 'view') ? (
         <Button type="submit" variant="contained" className="mt-3 ml-1 mr-1"  color="primary">
          Guardar
        </Button>
        ): ''
        }
      
        {(this.state.action !== 'view') ? (
        <Button variant="contained" className="mt-3 ml-1 mr-1" color="secondary" href={"/authorizationMatrices?idContract="+this.state.idContract}>
          Cancelar
        </Button>

          ):
            <div>
            <Button variant="contained" className="mt-3 ml-1 mr-1" color="primary" onClick={this.handlePreview}>
              Previsualizar
            </Button>
            <Button className="mt-3 ml-1 mr-1" href={api.authorization_matrix().export(this.state.idMatrix)} variant="contained" color="primary" >
                Descargar
            </Button>
            <Button variant="contained" className="mt-3 ml-1 mr-1" color="secondary" href={"/authorizationMatrices?idContract="+this.state.idContract}>
              Volver
            </Button>
            </div>
      }
        </form>
      );
    }
  }

  export default AuthorizationMatrixFormm;